import React from "react";
import ReactApexChart from "react-apexcharts";
function Chart(props: any) {
  const { options, series, type, height } = props;

  return (
    <div className="pw-width-100">
      <ReactApexChart
        options={options}
        series={series}
        type={type}
        height={height}
      />
    </div>
  );
}

export default Chart;
